import { StepItem as BeyondStepItem, styled } from '@zeiss/beyond-online-react';

export const StepItem: typeof BeyondStepItem = styled(BeyondStepItem)`
  /* Make the content container use the full width on mobile screens */
  & > div {
    flex: 1;
  }
`;
